import * as React from 'react'

import { Buttons } from './Buttons'
import { GoBack } from './GoBack'
import { Line } from './Line'
import { SuccessModal } from './modal'
import { TextView } from './TextView'

export class SuccessView extends React.Component<
  { title: string; message?: string; goBackUrl: string; onClose?: () => void },
  {}
> {
  render() {
    const { title, message, goBackUrl, onClose } = this.props
    return (
      <SuccessModal title={title} asModal={false}>
        <TextView>{message}</TextView>
        <Line />
        <Buttons>
          <GoBack
            href="#"
            onClick={e => {
              e.preventDefault()
              onClose && onClose()
            }}
            style={{ marginRight: 30 }}
          >
            Wypełnij formularz ponownie
          </GoBack>
          <GoBack href={goBackUrl}>Wróć do strony</GoBack>
        </Buttons>
      </SuccessModal>
    )
  }
}
